module.exports = __webpack_public_path__ + "img/slide_img_01_min.add3f9af.jpg";